import * as RadixTooltip from '@radix-ui/react-tooltip'
import type { ReactNode } from 'react'
import { useLayerHost } from './layerHost.ts'

/**
 * One provider at the app root: the first tooltip waits (intent), moving along a row of icons
 * after that shows them at once, the way a real toolbar behaves.
 */
export function TooltipProvider({ children }: { children: ReactNode }) {
	return (
		<RadixTooltip.Provider delayDuration={300} skipDelayDuration={300}>
			{children}
		</RadixTooltip.Provider>
	)
}

/** A label for an icon that has no words. Shows on hover and keyboard focus. */
export function Tooltip({
	label,
	side = 'top',
	children,
}: {
	label: string
	side?: 'top' | 'bottom' | 'left' | 'right'
	children: ReactNode
}) {
	const layer = useLayerHost()
	return (
		<RadixTooltip.Root>
			<RadixTooltip.Trigger asChild ref={layer.ref}>
				{children}
			</RadixTooltip.Trigger>
			<RadixTooltip.Portal container={layer.host}>
				<RadixTooltip.Content
					side={side}
					sideOffset={6}
					collisionPadding={8}
					className="z-(--z-toast) max-w-64 select-none rounded-input bg-teal-950 px-2.5 py-1.5 text-small font-medium text-white
						shadow-3 animate-fade-in"
				>
					{label}
				</RadixTooltip.Content>
			</RadixTooltip.Portal>
		</RadixTooltip.Root>
	)
}
